<template>
  <section>
    <div
      class="container pt-lg-md"
      style="padding-top: 2rem !important;margin-bottom: 14rem;"
    >
      <div class="row" style="margin-bottom: 1rem;" v-if="officer">
        <div class="col-sm">
          <div class="loanOfficer">
            <div class="officerInfo">
              <div
                class="heading-title"
                :class="{
                  'text-success': officerStatus,
                  'text-muted': !officerStatus,
                }"
                style="font-size: 14px;"
              >
                {{ officerStatus ? "Online" : "Offline" }}
              </div>
              <div class="name">{{ officer.Name }}</div>
              <div class="phone">
                <a :href="'tel:+' + officer.Phone" class="primary">{{
                  officer.Phone | phoneNumber
                }}</a>
              </div>
            </div>
            <div
              class="avatar"
              :style="{ 'background-image': `url(${officer.Image})` }"
            ></div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 1rem;">
        <div
          class="col-sm"
          style="display: flex;justify-content: space-between;align-items: center;"
        >
          <div>
            <h1 class="display-4" style="font-weight: lighter;font-size: 24px;">
              Mortgage Loan Overview
            </h1>
          </div>
          <div style="display: flex;">
            <div @click="scrollToDiv('application')">
              <round-icon
                style="margin-bottom: 0 !important; margin-right: .5rem; cursor: pointer"
                name="ni ni-single-copy-04"
                type="success"
                v-b-popover.hover.top="'Go To Application Overview'"
              ></round-icon>
            </div>
            <div @click="scrollToDiv('checklist')">
              <round-icon
                style="margin-bottom: 0 !important; margin-right: .5rem;cursor: pointer"
                name="ni ni-check-bold"
                type="info"
                @click="scrollToDiv('checklist')"
                v-b-popover.hover.top="'Go To Checklist'"
              ></round-icon>
            </div>
            <div @click="scrollToDiv('documents')">
              <round-icon
                style="margin-bottom: 0 !important; cursor: pointer"
                name="fa fa-hdd-o"
                type="primary"
                v-b-popover.hover.top="'Go To Documents'"
              ></round-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="app.progress" id="application">
        <div class="col-sm">
          <card shadow>
            <div class="row">
              <div class="col-sm">
                <div class="header">
                  <div style="display: flex;">
                    <round-icon
                      name="ni ni-single-copy-04"
                      type="success"
                    ></round-icon>
                    <!-- <div
                      class="icon icon-shape mb-4 icon-shape-success rounded-circle"
                    >
                      <i class="ni ni-single-copy-04"></i>
                    </div> -->
                    <h2 class="heading">Loan Application</h2>
                  </div>
                  <div v-if="!status">
                    <base-button type="default" @click="submitApp()"
                      >Submit Application</base-button
                    >
                  </div>
                  <div v-if="status" style="font-size: 18px;">
                    <i
                      class="fa fa-check-circle"
                      aria-hidden="true"
                      style="font-size: 24px;color: #2dce89;font-weight: bold;"
                    ></i>
                    Application Submitted
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="app.progress.sections.agreements">
              <div class="col-sm">
                <h5 style="font-size: 16px;">Agreements</h5>
                <base-progress
                  v-if="app.progress"
                  style="padding-top: 0;margin-top: -1.8rem;"
                  type="success"
                  :value="app.progress.sections.agreements.progress"
                  :showPercent="true"
                ></base-progress>
              </div>
              <div class="col-sm mob"></div>
            </div>
            <div
              class="row moreMob"
              v-if="app.progress.sections.coBorrower && !coBorrower"
            >
              <div class="col-sm">
                <h5 style="font-size: 16px;">Borrower(s)</h5>
                <base-progress
                  v-if="app.progress"
                  style="padding-top: 0;margin-top: -1.8rem;"
                  type="success"
                  :value="app.progress.sections.coBorrower.progress"
                  :showPercent="true"
                ></base-progress>
              </div>
              <div class="col-sm mob">
                <base-button
                  size="sm"
                  :type="
                    app.progress.sections.coBorrower.progress == 100
                      ? 'secondary'
                      : 'primary'
                  "
                  @click="finishApp('co-borrower')"
                  >Borrower(s)</base-button
                >
              </div>
            </div>
            <div class="row moreMob" v-if="app.progress.sections.documents">
              <div class="col-sm">
                <h5 style="font-size: 16px;">Documents</h5>
                <base-progress
                  v-if="app.progress"
                  style="padding-top: 0;margin-top: -1.8rem;"
                  type="success"
                  :value="app.progress.sections.documents.progress"
                  :showPercent="true"
                ></base-progress>
              </div>
              <div class="col-sm mob">
                <base-button
                  size="sm"
                  :type="
                    app.progress.sections.documents.progress == 100
                      ? 'secondary'
                      : 'primary'
                  "
                  @click="finishApp('documents')"
                  >Documents</base-button
                >
              </div>
            </div>
            <div class="row moreMob" v-if="app.progress.sections.fields">
              <div class="col-sm">
                <h5 style="font-size: 16px;">Application</h5>
                <base-progress
                  v-if="app.progress"
                  style="padding-top: 0;margin-top: -1.8rem;"
                  type="success"
                  :value="app.progress.sections.fields.progress"
                  :showPercent="true"
                ></base-progress>
              </div>
              <div class="col-sm mob">
                <base-button
                  size="sm"
                  :type="
                    app.progress.sections.fields.progress == 100
                      ? 'secondary'
                      : 'primary'
                  "
                  @click="finishApp('fields')"
                  >Application</base-button
                >
              </div>
            </div>
            <div class="row" v-if="pages.length">
              <div class="col-sm">
                <div class="h6">Completed Pages</div>
                <div class="pages">
                  <div
                    class="page"
                    v-for="page of pages"
                    :key="page.ID"
                    @click="gotoPage(page)"
                  >
                    <i class="ni ni-check-bold text-success success"></i>
                    <div class="fontPrimary">{{ page.Title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div
        class="row"
        v-if="
          (coBorrowers &&
            coBorrowers.accepted &&
            coBorrowers.accepted.length) ||
            (coBorrowers && coBorrowers.invited && coBorrowers.invited.length)
        "
        id="coBorrower"
        style="margin-top: 2rem"
      >
        <div class="col-sm">
          <card shadow>
            <div class="row">
              <div class="col-sm">
                <div class="header">
                  <div
                    class="icon icon-shape mb-4 icon-shape-success rounded-circle"
                  >
                    <i class="fa fa-user"></i>
                  </div>
                  <h2 class="heading">Co-Borrower(s)</h2>
                </div>
              </div>
            </div>
            <div v-if="coBorrowers.accepted.length">
              <div
                v-for="cob of coBorrowers.accepted"
                :key="cob.ProductUserGUID"
              >
                <div class="row">
                  <div
                    class="col-sm"
                    v-if="cob.FirstName"
                    style="border-bottom: 1px solid #e9ecef;padding: 1rem 1rem 0;margin-bottom: 1rem;border-radius: 4px;"
                  >
                    <div style="padding: 0;font-weight: bolder;color: #525f7f;">
                      {{ cob.FirstName }} {{ cob.LastName }}
                    </div>
                    <div style="padding: 0 0 1rem;color: #525f7f;">
                      {{ cob.Email }}
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="cob.LoanAppJSON.progress.sections.agreements"
                >
                  <div class="col-sm">
                    <h5 style="font-size: 16px;">Agreements</h5>
                    <base-progress
                      v-if="app.progress"
                      style="padding-top: 0;margin-top: -1.8rem;"
                      type="success"
                      :value="
                        cob.LoanAppJSON.progress.sections.agreements.progress
                      "
                      :showPercent="true"
                    ></base-progress>
                  </div>
                </div>
                <div
                  class="row moreMob"
                  v-if="cob.LoanAppJSON.progress.sections.documents"
                >
                  <div class="col-sm">
                    <h5 style="font-size: 16px;">Documents</h5>
                    <base-progress
                      v-if="app.progress"
                      style="padding-top: 0;margin-top: -1.8rem;"
                      type="success"
                      :value="
                        cob.LoanAppJSON.progress.sections.documents.progress
                      "
                      :showPercent="true"
                    ></base-progress>
                  </div>
                </div>
                <div
                  class="row moreMob"
                  v-if="cob.LoanAppJSON.progress.sections.fields"
                >
                  <div class="col-sm">
                    <h5 style="font-size: 16px;">Application</h5>
                    <base-progress
                      v-if="app.progress"
                      style="padding-top: 0;margin-top: -1.8rem;"
                      type="success"
                      :value="cob.LoanAppJSON.progress.sections.fields.progress"
                      :showPercent="true"
                    ></base-progress>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="coBorrowers.invited.length" style="margin-bottom">
              <div v-for="cob of coBorrowers.invited" :key="cob.FirstName">
                <div
                  class="row"
                  style="background: #f6f9fc;padding: 1rem 0;border-radius: 8px;margin: 0 0rem .4rem;"
                >
                  <div
                    class="col"
                    style="display: flex;align-items: center;justify-content: space-between;"
                  >
                    <div style="display: flex;align-items: center;">
                      <div>{{ cob.FirstName }} {{ cob.LastName }}</div>
                      <div
                        class="hideMobile"
                        style="font-weight: lighter;margin-left: 10px;"
                      >
                        ({{ cob.Email }})
                      </div>
                      <div
                        class="status"
                        style="margin-left: 2rem; font-weight: bold"
                        :style="{
                          color:
                            cob.Status == 'Invited'
                              ? $theme.primary
                              : $theme.warning,
                        }"
                      >
                        {{ cob.Status }}
                      </div>
                    </div>

                    <div
                      v-if="cob.Status == 'Expired'"
                      @click="resendInvite(cob)"
                      style="margin-left: 20px;cursor: pointer;"
                      :style="{ color: $theme.primary }"
                    >
                      Resend
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <!-- CheckList -->
      <div class="row" style="margin-top: 2rem" id="checklist">
        <div class="col-sm">
          <card shadow>
            <div class="row">
              <div class="col-sm">
                <div class="header">
                  <round-icon name="ni ni-check-bold" type="info"></round-icon>
                  <h2 class="heading">Check List</h2>
                </div>
                <p style="margin-top: -1rem;">
                  Here is a checklist of thing you and your loan officer will
                  need to complete. You will be notified when your officer
                  checks an item off or updates an item.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="checklist" id="checklistHolder">
                  <div
                    v-for="item of checklist"
                    :key="item.ID"
                    class="itemHolder"
                  >
                    <div
                      class="item"
                      v-if="item.ForLoanUser && !item.DoesNotApply"
                    >
                      <div class="complete" v-if="item.Owner === 'officer'">
                        <i
                          v-if="item.Completed"
                          class="fa fa-check"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div
                        class="complete"
                        v-if="item.Owner === 'user'"
                        style="cursor: pointer;"
                        @click="
                          item.Completed = !item.Completed;
                          updateChecklistItem(item);
                        "
                      >
                        <i
                          v-if="!item.Completed"
                          style="opacity: 0;"
                          class="fa fa-square-o"
                          aria-hidden="true"
                        ></i>

                        <i
                          v-if="item.Completed"
                          class="fa fa-check info"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div class="nameDesc" style="flex: 1">
                        <div class="name">{{ item.Name }}</div>
                        <div class="description">{{ item.Description }}</div>
                      </div>
                      <div class="holder">
                        <div
                          class="ordered"
                          v-if="item.Ordered && item.Ordered !== true"
                        >
                          <div class="title">Ordered</div>
                          <div class="date">
                            {{ item.Ordered === true ? "" : item.Ordered }}
                          </div>
                        </div>
                      </div>

                      <div class="holder">
                        <div
                          class="received"
                          v-if="item.Received && item.Received !== true"
                        >
                          <div class="title">Received</div>
                          <div class="date">
                            {{ item.Received === true ? "" : item.Received }}
                          </div>
                        </div>
                      </div>
                      <div class="edit">
                        <i
                          v-if="item.UserCreated"
                          style="padding-right: 1rem;cursor: pointer;"
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                          @click="openCheckListEdit(item)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <base-button
                  type="link"
                  class="ml-auto info"
                  style="margin-top: 1rem; color: #11cdef;"
                  @click="newListItem = true"
                  ><i class="fa fa-check-square-o info" aria-hidden="true"></i>
                  Add item
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div
        class="row"
        style="margin-top: 2rem; margin-bottom: 1rem"
        id="documents"
      >
        <div class="col-sm">
          <card shadow>
            <div class="header">
              <round-icon name="fa fa-hdd-o" type="primary"></round-icon>
              <h2 class="heading">Documents</h2>
            </div>
            <p style="margin-top: -1rem;">
              Here is a list of all your documents. Your loan officer also has
              access to these files. You can upload additional documents at
              anytime. To open a folder or document double click.
            </p>
            <div class="row">
              <div class="col-sm">
                <div class="loader" v-if="loading">
                  <div class="loader-box">
                    <i
                      class="fa fa-spinner success"
                      :style="{ color: $theme.success }"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>

                <div class="utils">
                  <div class="path">
                    <i
                      v-if="files.dirStructure.length"
                      @click="back"
                      class="fa fa-arrow-left"
                      aria-hidden="true"
                      v-b-popover.hover.top="'Back'"
                    ></i>
                  </div>
                  <div>
                    <i
                      class="fa fa-download"
                      aria-hidden="true"
                      @click="downloadAll"
                      v-b-popover.hover.top="'Download all Documents'"
                    ></i>
                    <i
                      class="fa fa-upload"
                      aria-hidden="true"
                      @click="openUpload"
                      v-b-popover.hover.top="'Upload Document to this folder'"
                    ></i>
                    <i
                      class="fa fa-folder"
                      aria-hidden="true"
                      @click="newFolder = true"
                      v-b-popover.hover.top="'Add new folder'"
                    ></i>
                  </div>
                </div>
                <div class="documents">
                  <div class="path">
                    <i
                      :style="{ color: $theme.primary }"
                      @click="gotoFolder({ path: '/' })"
                      class="fa fa-folder-open-o"
                      aria-hidden="true"
                      style="cursor: pointer"
                    ></i>
                    <div class="el">/</div>
                    <div
                      class="el"
                      v-for="(path, i) of files.dirStructure"
                      :key="i"
                      :style="{ color: $theme.primary }"
                      @click="gotoFolder(path)"
                    >
                      {{ path.name }}
                      <span
                        style="padding: 0 0 0 4px;"
                        v-if="i != files.dirStructure.length - 1"
                        >/</span
                      >
                    </div>
                  </div>
                  <div class="noDocs" v-if="!files.data.length && !loading">
                    No Documents
                  </div>
                  <div
                    class="doc"
                    v-for="(file, i) of files.data"
                    :key="file.tempID"
                    :class="{ selected: file.selected }"
                  >
                    <div
                      class="docInfo"
                      @dblclick="gotodoc(file)"
                      @click="alterClicks(i)"
                      style="position: relative"
                    >
                      <i
                        v-if="
                          file.type == '.jpg' ||
                            file.type == '.png' ||
                            file.type == '.jpeg'
                        "
                        class="fa fa-file-image-o"
                        aria-hidden="true"
                      ></i>
                      <i
                        v-if="file.type == '.pdf'"
                        class="fa fa-file-pdf-o"
                        aria-hidden="true"
                      ></i>
                      <i
                        v-if="
                          file.type != '.jpg' &&
                            file.type != '.png' &&
                            file.type != '.jpeg' &&
                            file.type != 'directory' &&
                            file.type != '.pdf'
                        "
                        class="fa fa-file-text-o"
                        aria-hidden="true"
                      ></i>
                      <i
                        v-if="file.type == 'directory'"
                        class="fa fa-folder-o"
                        aria-hidden="true"
                      ></i>
                      <div class="about">
                        <div class="name" style="word-wrap: anywhere;">
                          {{ file.name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="file.selected">
                      <i
                        v-if="file.stats.removable"
                        class="fa fa-trash text-danger danger"
                        style="padding: 0 0 0 20px;"
                        aria-hidden="true"
                        @click="
                          deleteConfirm = true;
                          deleteFile = file;
                        "
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input
              id="fileUpload-ipt"
              type="file"
              name=""
              style="display: none"
              accept=".xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv"
            />
            <base-button
              type="link"
              class="ml-auto primary"
              style="margin-top: 1rem"
              @click="openUpload"
            >
              Upload <i class="fa fa-upload" aria-hidden="true"></i>
            </base-button>
          </card>
        </div>
      </div>
      <div class="row" style="margin-bottom: 4rem">
        <div class="col-sm" style="text-align: right;">
          <base-button type="danger" @click="deleteAppConfirm = true"
            ><i class="fa fa-trash" aria-hidden="true"></i> Delete
            Application</base-button
          >
        </div>
      </div>
    </div>
    <modal :show.sync="newFolder">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        New Folder
      </h6>
      <base-input
        v-model="newFolderName"
        placeholder="Folder name"
      ></base-input>
      <template slot="footer">
        <base-button type="primary" @click="makeNewFolder">Create</base-button>
        <base-button
          type="link"
          class="ml-auto primary"
          @click="newFolder = false"
          >Close
        </base-button>
      </template>
    </modal>
    <modal :show.sync="fileInfoModal">
      <h6
        v-if="fileInfo"
        slot="header"
        class="modal-title"
        id="modal-title-default"
        style="word-wrap: anywhere;"
      >
        {{ fileInfo.name }}
      </h6>
      <div class="infoHold" v-if="fileInfo">
        <div class="icon" :style="{ 'background-color': $theme.success }">
          <i
            v-if="
              fileInfo.type == '.jpg' ||
                fileInfo.type == '.png' ||
                fileInfo.type == '.jpeg'
            "
            class="fa fa-file-image-o"
            aria-hidden="true"
          ></i>
          <i
            v-if="fileInfo.type == '.pdf'"
            class="fa fa-file-pdf-o"
            aria-hidden="true"
          ></i>
          <i
            v-if="
              fileInfo.type != '.jpg' &&
                fileInfo.type != '.png' &&
                fileInfo.type != '.jpeg' &&
                fileInfo.type != 'folder' &&
                fileInfo.type != '.pdf'
            "
            class="fa fa-file-text-o"
            aria-hidden="true"
          ></i>
        </div>
        <div class="default">
          <div class="item">Uploaded: {{ fileInfo.stats.ctime }}</div>
          <div class="item">Size: {{ fileInfo.stats.size }}</div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="link" class="success" @click="downloadFile(fileInfo)"
          >Download <i class="fa fa-download" aria-hidden="true"></i>
        </base-button>
        <base-button
          type="link"
          class="ml-auto text-danger danger"
          @click="
            deleteConfirm = true;
            deleteFile = fileInfo;
          "
          >Delete
        </base-button>
      </template>
    </modal>
    <modal :show.sync="deleteConfirm" modal-classes="modal-dialog-centered">
      <h6
        slot="header"
        class="modal-title danger"
        style="color: #f5365c;"
        id="modal-title-notification"
      >
        Delete Document
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-trash text-danger danger" style="font-size: 42px"></i>
        <h4 class="heading mt-4">Are you sure?</h4>
        <p v-if="deleteFile && deleteFile.type != 'folder'">
          This will delete {{ deleteFile.name }}. Your loan officer will no
          longer be able the access this.
        </p>
        <p v-if="deleteFile && deleteFile.type == 'folder'">
          This will delete {{ deleteFile.name }} and all files in the folder.
          Your loan officer will no longer be able the access this.
        </p>
      </div>

      <template slot="footer">
        <base-button type="danger" @click="deleteDocument">Delete</base-button>
        <base-button
          type="link"
          class="ml-auto primary"
          @click="deleteConfirm = false"
        >
          Close
        </base-button>
      </template>
    </modal>
    <modal :show.sync="submitConfirm" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Submit Application
      </h6>

      <div class="py-3 text-center">
        <i
          class="fa fa-share-square-o"
          style="color: #2dce89; font-size: 42px"
          aria-hidden="true"
        ></i>
        <h4 class="heading mt-4">Are you sure?</h4>
        <p>
          Your have not completed all sections. Please revisit the incomplete
          sections and complete them. If you still want to submit your
          application click the submit button below.
        </p>
      </div>

      <template slot="footer">
        <base-button type="success" @click="submitApp(true)"
          >Submit</base-button
        >
        <base-button type="link" class="ml-auto" @click="submitConfirm = false">
          Close
        </base-button>
      </template>
    </modal>
    <modal :show.sync="deleteAppConfirm" modal-classes="modal-dialog-centered">
      <h6
        slot="header"
        class="modal-title"
        style="color: #f5365c;"
        id="modal-title-notification"
      >
        Delete Application
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-trash text-danger danger" style="font-size: 42px"></i>
        <h4 class="heading mt-4">Are you sure?</h4>
        <p>
          This will delete this application. Your loan officer will no longer be
          able the access it.
          <span style="font-weight: bold;">THIS CAN NOT BE RECOVERED.</span>
        </p>
      </div>

      <template slot="footer">
        <base-button type="danger" @click="deleteApp">Delete</base-button>
        <base-button type="link" class="ml-auto" @click="deleteConfirm = false">
          Close
        </base-button>
      </template>
    </modal>
    <modal :show.sync="newListItem" modal-classes="modal-dialog-centered">
      <h6
        slot="header"
        class="modal-title"
        style="color: #11cdef;"
        id="modal-title-notification"
      >
        <i class="fa fa-check-square-o" aria-hidden="true"></i> New Checklist
        Item
      </h6>

      <base-input v-model="newItemName" placeholder="Title"></base-input>
      <textarea
        class="form-control"
        rows="2"
        placeholder="Description"
        v-model="newItemDesc"
      ></textarea>
      <base-checkbox
        class="mb-3"
        v-model="newItemOfficerAssign"
        style="margin-bottom: 0 !important;margin-top: 2rem;"
      >
        Assign to your loan officer.
      </base-checkbox>
      <small
        >This will assign this checklist item to your loan officer. Only they
        will be bale to check it as complete.</small
      >
      <template slot="footer">
        <base-button type="info" @click="AddCheckListItem()">Add</base-button>
        <base-button
          type="outline secondary"
          class="ml-auto"
          @click="newListItem = false"
        >
          Close
        </base-button>
      </template>
    </modal>
    <modal :show.sync="editListItem" modal-classes="modal-dialog-centered">
      <h6
        slot="header"
        class="modal-title"
        style="color: #11cdef;"
        id="modal-title-notification"
      >
        <i class="fa fa-check-square-o" aria-hidden="true"></i> Edit Checklist
        Item
      </h6>

      <base-input v-model="editItem.Name" placeholder="Title"></base-input>
      <textarea
        class="form-control"
        rows="2"
        placeholder="Description"
        v-model="editItem.Description"
      ></textarea>
      <base-checkbox
        class="mb-3"
        v-model="editItemOfficerAssign"
        style="margin-bottom: 0 !important;margin-top: 2rem;"
      >
        Assign to your loan officer.
      </base-checkbox>
      <small
        >This will assign this checklist item to your loan officer. Only they
        will be bale to check it as complete.</small
      >
      <template slot="footer">
        <base-button type="info" @click="editChecklistItem(editItem)"
          >Save</base-button
        >
        <i
          @click="removeChecklistItem(editItem)"
          style="color: #f5365c;font-size: 24px;padding: 0 1rem; cursor: pointer"
          class="fa fa-trash-o danger"
          aria-hidden="true"
          v-b-popover.hover.top="'Delete Item'"
        ></i>
        <base-button
          type="outline secondary"
          class="ml-auto"
          @click="newListItem = false"
        >
          Close
        </base-button>
      </template>
    </modal>
  </section>
</template>

<script>
import Vue from "vue";
import { success, warning, message } from "../services/message";
import {
  uploadDocument,
  getAllDocuments,
  newDocumentFolder,
  removeFile,
  removeFolder,
  download,
  downloadAllFiles,
} from "../services/documents";
import {
  getApplication,
  getAllPages,
  getCoBorrowerProgress,
  deleteApplication,
  submitApplication,
} from "../services/application";
import { getLoanOfficer } from "../services/officers";
import BaseInput from "../components/BaseInput.vue";
import { broadcast } from "../main";
import {
  getApplicationChecklist,
  addApplicationChecklistItem,
  updateApplicationChecklistItem,
  removeApplicationChecklistItem,
} from "../services/checklist";
export default {
  components: { BaseInput },
  name: "mainApplication",
  filters: {
    phoneNumber(value) {
      if (!value) return "";
      let cleaned = ("" + value).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      }
      return null;
    },
  },
  data() {
    return {
      app: {},
      files: {
        data: [],
        parentDir: "",
        currentDir: "/",
        dirStructure: [],
      },
      loading: false,
      newFolder: false,
      newFolderName: "",
      fileInfoModal: false,
      fileInfo: null,
      deleteConfirm: false,
      deleteFile: null,
      pages: [],
      loadingDA: false,
      coBorrower: true,
      doubleClick: false,
      officer: null,
      officerStatus: false,
      newListItem: false,
      editListItem: false,
      editItem: {},
      editItemOfficerAssign: false,
      newItemName: "",
      newItemDesc: "",
      newItemOfficerAssign: false,
      checklist: { checklist: [] },
      coBorrowers: false,
      deleteAppConfirm: false,
      status: false,
      submitConfirm: false,
      infoColor: this.$theme.info,
      infoLightColor: this.$theme.infoLight,
    };
  },
  async created() {
    window.addEventListener("theme", () => {
      (this.infoColor = this.$theme.info),
        (this.infoLightColor = this.$theme.infoLight);
    });

    if (this.$route.params.id !== "new") {
      let res = await getApplication(this.$route.params.id);
      if (res.status === 200) {
        if (!res.LoanAppJSON.progress) {
          this.$router.push(`/application/${this.$route.params.id}/agreements`);
          return;
        }
        if (res.OfficerNeedsSelected) {
          this.$router.push(`/application/${this.$route.params.id}/officer`);
          return;
        }
        this.coBorrower = res.coBorrower;
        this.app = res.LoanAppJSON;
        this.status = res.Submitted;
      } else {
        this.$router.push("/");
        warning(res.message);
      }
      this.getOfficer();
      this.getChecklist();
      this.getLoanDocuments();
      this.coBorrowers = await getCoBorrowerProgress(this.$route.params.id);
      let result = await getAllPages(1);
      if (result.status === 200) {
        result.pages.forEach((p) => {
          this.app.progress.sections.fields.pages.forEach((e) => {
            if (e.id == p.PageID) {
              this.pages.push(p);
            }
          });
        });
      }
    } else {
      this.$router.push("/application/new/agreements");
    }

    if (
      this.officer &&
      broadcast.statuses &&
      broadcast.statuses[this.officer.ID.toLowerCase()]
    ) {
      this.officerStatus = broadcast.statuses[this.officer.ID.toLowerCase()];
      message(
        `${this.officer.Name} is ${
          broadcast.statuses[this.officer.ID.toLowerCase()]
            ? "<strong style='color:#2dce89'>ONLINE</strong>"
            : "<strong>OFFLINE</strong>"
        }`,
        this.officer.Image
      );
    }
  },
  methods: {
    async getOfficer() {
      let res = await getLoanOfficer(this.$route.params.id);
      if (res.officer) {
        this.officer = res.officer;
      }

      Vue.socket.on(`userStatus.${this.officer.ID.toLowerCase()}`, (msg) => {
        this.officerStatus = msg.status;
        message(
          `${this.officer.Name} is ${msg.status ? "Online" : "Offline"}`,
          this.officer.Image
        );
      });

      Vue.socket.emit("getUserStatus", {
        product: Vue.product,
        domain: window.location.hostname,
        uid: this.officer.ID,
      });
    },
    async getChecklist() {
      let data = await getApplicationChecklist(this.$route.params.id, 1);
      if (data.status === 200) {
        this.checklist = data.data;
      }
    },
    openCheckListEdit(item) {
      this.editItem = item;
      if (item.Owner === "officer") this.editItemOfficerAssign = true;

      this.editListItem = true;
    },
    async AddCheckListItem() {
      let defItem = {
        Name: this.newItemName,
        Description: this.newItemDesc,
        Ordered: true,
        ShowOrdered: true,
        Received: true,
        ShowReceived: true,
        Completed: false,
        DoesNotApply: false,
        ForLoanUser: true,
        Owner: this.newItemOfficerAssign ? "officer" : "user",
        NotifyJSON: {
          officers: this.newItemOfficerAssign,
          agent: true,
          admins: false,
          loanUser: true,
        },
      };

      await addApplicationChecklistItem(this.$route.params.id, defItem, 1);

      this.checklist.push(defItem);
      this.newListItem = false;
      let div = document.getElementById("checklistHolder");
      div.scrollTop = div.scrollHeight + 35;

      this.newItemName = "";
      this.newItemDesc = "";
      this.newItemOfficerAssign = false;
    },
    async removeChecklistItem(item) {
      try {
        await removeApplicationChecklistItem(this.$route.params.id, item, 1);
        this.editListItem = false;
        this.editItem = {};
        this.getChecklist();
        success("Item removed");
      } catch (error) {
        warning(error.message);
      }
    },
    async submitApp(override) {
      try {
        if (
          override ||
          (this.app.progress.sections.agreements.progress === 100 &&
            this.app.progress.sections.fields.progress === 100 &&
            this.app.progress.sections.documents.progress === 100)
        ) {
          await submitApplication(this.$route.params.id);
          this.status = true;
          this.submitConfirm = false;
          success("Application Submitted");
        } else {
          this.submitConfirm = true;
        }
      } catch (error) {
        warning(error.message);
      }
    },
    async updateChecklistItem(item) {
      try {
        await updateApplicationChecklistItem(this.$route.params.id, item, 1);
        success("Item updated");
      } catch (error) {
        warning(error.message);
      }
    },
    async editChecklistItem(item) {
      item.Owner = this.editItemOfficerAssign ? "officer" : "user";
      item.NotifyJSON.officers = this.editItemOfficerAssign;
      try {
        await updateApplicationChecklistItem(this.$route.params.id, item, 1);
        this.editListItem = false;
        this.editItem = {};
        this.getChecklist();
        success("Item Saved");
      } catch (error) {
        warning(error.message);
      }
    },
    gotoPage(page) {
      this.$router.push(
        `/application/${this.$route.params.id}/fields/${page.PageID}?type=${
          page.ConditionalPage ? "c" : "r"
        }`
      );
    },
    finishApp(des) {
      this.$router.push(`/application/${this.$route.params.id}/${des}`);
    },
    async getLoanDocuments(folder) {
      this.loading = true;
      try {
        this.files = await getAllDocuments(folder, this.$route.params.id);
        this.loading = false;
      } catch (error) {
        warning(error);
      }
    },
    scrollToDiv(id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    async downloadAll() {
      this.loading = true;
      await downloadAllFiles(this.$route.params.id);
      this.loading = false;
    },
    async downloadFile(file) {
      await download(file, this.$route.params.id);
      this.fileInfoModal = false;
    },
    async deleteApp() {
      try {
        await deleteApplication(this.$route.params.id);
        this.deleteAppConfirm = false;
        this.$router.push({
          name: "main",
        });
        success("Application Deleted");
      } catch (error) {
        warning(error);
      }
    },
    async deleteDocument() {
      this.loading = true;
      try {
        if (
          this.deleteFile.type === "folder" ||
          this.deleteFile.type === "directory"
        ) {
          await removeFolder(this.deleteFile.path, this.$route.params.id);
          this.getLoanDocuments(this.files.parentDir);
          success("Folder Deleted");
        } else {
          await removeFile(this.deleteFile.path, this.$route.params.id);
          success("Document Deleted");
          this.getLoanDocuments(this.files.currentDir);
        }
      } catch (error) {
        warning(error);
      }
      this.loading = false;
      this.deleteConfirm = false;
      this.deleteFile = null;
    },
    alterClicks(index) {
      setTimeout(() => {
        if (!this.doubleClick) {
          this.files.data.forEach((f, i) => {
            if (i == index) {
              f.selected = true;
            } else {
              f.selected = false;
            }
          });
        }
      }, 200);
    },
    gotodoc(file) {
      this.doubleClick = true;
      if (file.type === "directory") {
        this.getLoanDocuments(file.path);
      } else {
        this.fileInfo = file;
        this.fileInfoModal = true;
      }
      setTimeout(() => {
        this.doubleClick = false;
      }, 100);
    },
    gotoFolder(folder) {
      this.getLoanDocuments(folder.path);
    },
    async makeNewFolder() {
      this.loading = true;
      let path =
        this.files.currentDir == "/"
          ? this.newFolderName
          : this.files.currentDir + "/" + this.newFolderName;
      await newDocumentFolder(path, this.$route.params.id);
      this.newFolder = false;
      this.getLoanDocuments(this.files.currentDir + "/" + this.newFolderName);
    },
    back() {
      this.getLoanDocuments(this.files.parentDir);
    },
    openUpload() {
      let input = document.getElementById("fileUpload-ipt");
      input.addEventListener("change", async (event) => {
        this.uploadFile(event);
      });
      input.click();
    },
    async uploadFile(event) {
      try {
        this.loading = true;
        // if ext check
        if (event.target.files[0].type !== "") {
          await uploadDocument(
            event,
            this.$route.params.id,
            this.files.currentDir
          );
          this.getLoanDocuments(this.files.currentDir);
          success("Document Upload Successful");
        } else {
          warning("Document must have a file extension.");
        }

        let input = document.getElementById("fileUpload-ipt");
        let newInput = document.createElement("input");
        newInput.type = "file";
        newInput.id = "fileUpload-ipt";
        newInput.style = "display: none";
        input.replaceWith(newInput);
      } catch (error) {
        warning("Error Uploading Document");
      }
    },
  },
};
</script>
<style lang="scss">
.utils {
  background-color: #f6f9fc;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-right: 1px solid #e9ecef;
  border-left: 1px solid #e9ecef;
  border-top: 1px solid #e9ecef;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  i {
    font-size: 1.5rem;
    padding: 0 0.5rem;
    cursor: pointer;
  }
}
.documents {
  border-right: 1px solid #e9ecef;
  border-left: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  .path {
    display: flex;
    border-bottom: 1px solid #e9ecef;
    padding: 0 6px 8px;
    margin-bottom: 8px;
    align-items: center;
    i {
      padding-right: 6px;
    }
    .el {
      padding: 0 4px;
      cursor: pointer;
      span {
        color: #525f7f;
      }
    }
  }
  .noDocs {
    text-align: center;
    color: #ced4da;
    padding: 0.5rem 0;
  }
  .doc {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    justify-content: space-between;
    margin: 0 -1rem;
    cursor: pointer;
    user-select: none;
    &.selected {
      background-color: #f6f9fc;
    }
    .docInfo {
      display: flex;
    }
    i {
      padding-right: 1rem;
      font-size: 1.5rem;
      color: #525f7f;
    }
  }
}
.header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .heading {
    padding: 1rem;
  }
}
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  margin-top: 8px;
}
.loader-box {
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: relative;
  i {
    font-size: 30px;
  }
}
.fa-spinner {
  animation: spin 1.8s linear 0s infinite;
}
.infoHold {
  display: flex;
  align-items: center;
  .icon {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: 1rem;
    i {
      font-size: 26px;
    }
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.pages {
  max-height: 200px;
  overflow: scroll;
  background: #f6f9fc;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  .page {
    display: flex;
    align-items: center;
    cursor: pointer;
    i {
      margin-right: 8px;
    }
  }
}
.loanOfficer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .avatar {
    width: 80px;
    margin-left: 1rem;
    height: 80px;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: white;
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1),
      0 5px 15px rgba(0, 0, 0, 0.07) !important;
  }
  .officerInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
}

@media (max-width: 575px) {
  .moreMob {
    margin-bottom: 2rem;
    .mob {
      text-align: right;
    }
  }
  .loanOfficer {
    margin-bottom: 2rem;
  }
}
.checklist {
  max-height: 300px;
  overflow-y: scroll;
  .itemHolder {
    &:last-of-type {
      padding-bottom: 2rem;
    }
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 0.5rem;

    .complete {
      border: 1px solid #e9ecef;
      padding: 0 4px;
      margin: 0 1rem 0 0;
      border-radius: 4px;
      color: #11cdef;
      min-width: 26px;
    }
    .holder {
      text-align: center;
      flex: 1;
    }
    .title {
      font-size: 12px;
    }
    .date {
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
